import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=80ba76e2&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=80ba76e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ba76e2",
  null
  
)

export default component.exports